import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const MAX_ATTACHMENTS = 5;
export const MAX_PER_FILE_BYTES = 10 * 1024 * 1024;   // 10 MB
export const MAX_TOTAL_BYTES = 15 * 1024 * 1024;       // 15 MB
export const ALLOWED_EXTENSIONS = new Set([
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv',
  'jpg', 'jpeg', 'png', 'gif', 'webp',
]);

export function getFileExt(name) {
  return name.includes('.') ? name.rsplit?.('.')?.pop()?.toLowerCase() ?? name.split('.').pop().toLowerCase() : '';
}

export function formatBytes(bytes) {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getFileIcon(mimeOrName, sx = { fontSize: 18 }) {
  const s = (mimeOrName || '').toLowerCase();
  if (s.includes('pdf')) return <PictureAsPdfIcon sx={{ ...sx, color: '#e53935' }} />;
  if (s.includes('image') || /\.(jpg|jpeg|png|gif|webp)$/.test(s))
    return <ImageIcon sx={{ ...sx, color: '#43a047' }} />;
  if (s.includes('sheet') || /\.(xls|xlsx|csv)$/.test(s))
    return <TableChartIcon sx={{ ...sx, color: '#1e88e5' }} />;
  if (s.includes('presentation') || /\.(ppt|pptx)$/.test(s))
    return <SlideshowIcon sx={{ ...sx, color: '#fb8c00' }} />;
  if (s.includes('word') || /\.(doc|docx|txt)$/.test(s))
    return <ArticleIcon sx={{ ...sx, color: '#3949ab' }} />;
  return <InsertDriveFileIcon sx={{ ...sx, color: '#757575' }} />;
}
